import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { trackEvent } from './analytics';
import './App.css';

function PrivacyPolicy() {
    useEffect(() => {
        trackEvent('page_view', 'privacy_policy');
    }, []);

    return (
        <div className="privacy-container fade-in">
            <div className="nav-header">
                <Link to="/" className="back-link">
                    ← Back to Music
                </Link>
            </div>

            <div className="privacy-content">
                <h1>Privacy Policy</h1>
                <p className="last-updated">Last Updated: February 10, 2026</p>

                <section>
                    <h2>1. Information We Collect</h2>
                    <p>We collect information to provide better services to our users. This includes:</p>
                    <ul>
                        <li><strong>Voluntary Information:</strong> Name, email, Instagram handle, and media files submitted via our forms.</li>
                        <li><strong>Automated Information:</strong> IP addresses, browser type, operating system, and screen resolution.</li>
                        <li><strong>Behavioral Data:</strong> Patterns of interaction with our music players and site navigation.</li>
                    </ul>
                </section>

                <section>
                    <h2>2. How We Use Information</h2>
                    <p>We use the collected data for:</p>
                    <ul>
                        <li>Direct communication regarding your music submissions.</li>
                        <li>Analyzing site engagement to improve the user experience.</li>
                        <li>Course location mapping to understand our audience reach.</li>
                    </ul>
                </section>

                <section>
                    <h2>3. Data Protection</h2>
                    <p>We do not sell, trade, or otherwise transfer your personally identifiable information to outside parties. Your data is stored securely on our private servers.</p>
                </section>

                <section>
                    <h2>4. Your Rights</h2>
                    <p>You may request to view or delete any personal information we hold about you by contacting us at the email provided in the footer.</p>
                </section>

                <section>
                    <h2>5. Consent</h2>
                    <p>By using our site, you consent to our privacy policy.</p>
                </section>
            </div>
        </div>
    );
}

export default PrivacyPolicy;
